import { api } from '@/utils/api';
import axios from 'axios';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from '../store';

// Definimos el tipo de estado para `maps`
interface MapData {
  [key: string]: any;
}

interface MapsState {
  fetching: boolean;
  array: MapData;
  current: Record<string, any>;
  error?: string;
}

// Estado inicial de `maps`
const initialState: MapsState = {
  fetching: false,
  array: {},
  current: {},
};

const mapsSlice = createSlice({
  name: 'maps',
  initialState,
  reducers: {
    getMap(state) {
      state.fetching = true;
    },
    getMapSuccess(state, action: PayloadAction<MapData>) {
      state.fetching = false;
      state.array = action.payload;
    },
    getMapError(state, action: PayloadAction<string>) {
      state.fetching = false;
      state.error = action.payload;
    },
  },
});

export const { getMap, getMapSuccess, getMapError } = mapsSlice.actions;
export default mapsSlice.reducer;

// Thunk para obtener los mapas
export const getMapsAction = (id: string) => async (dispatch: AppDispatch) => {
  if (!id) return;
  dispatch(getMap());

  try {
    const res = await fetcher(id);
    dispatch(getMapSuccess(res));
  } catch (err: any) {
    console.error(err);
    dispatch(getMapError(err?.response?.message || 'Error fetching map'));
  }
};

const fetcher = async (id: string) => {
  const response = await api.get(`maps/${id}/data`);
  return response.data;
};
